import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  hasUnsavedChanges: false,
  isConfirmedType: '',
};

const UnsavedSlice = createSlice({
  name: 'unsaved',
  initialState,
  reducers: {
    setUnsavedChanges: (state, action) => {
      state.hasUnsavedChanges = action.payload;
    },
    setConfirmed: (state, action) => {
      state.isConfirmedType = action.payload;
    },
  },
});

export const { setUnsavedChanges, setConfirmed } = UnsavedSlice.actions;
export default UnsavedSlice.reducer;
